import styled from "styled-components";

interface FlightIconProps {
  mobileSrc: string;
  desktopSrc: string;
}

const FlightIcon = styled.img<FlightIconProps>`
  content: ${({ desktopSrc }) => `url(${desktopSrc})`};

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    content: ${({ mobileSrc }) => `url(${mobileSrc})`};
  }
`;

export default FlightIcon;
